const SCRIPT_ID = 'umami-tracker-script'

/** Unlinked, only reachable via the direct URL (see App.tsx) - not a page real visitors land on,
 *  so it shouldn't pollute the Umami dashboard's pageview/event stats with the site owner's own
 *  admin usage. */
const EXCLUDED_PATH_PREFIX = '/admin-console'

/** Injects the self-hosted Umami tracker script at runtime instead of baking it statically into
 *  index.html (see ANALYTICS.md) - the only way to keep it off /admin-console, since a static
 *  <script> tag has no way to know the current route before it loads. Same-origin path/website ID
 *  as the previous static tag (nginx proxies /script.js and /api/send to the umami container).
 *  Idempotent - safe to call more than once without injecting a duplicate tag. */
export function loadUmami(): void {
  if (window.location.pathname.startsWith(EXCLUDED_PATH_PREFIX)) return
  if (document.getElementById(SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = SCRIPT_ID
  script.defer = true
  script.src = '/script.js'
  script.dataset.websiteId = import.meta.env.VITE_UMAMI_WEBSITE_ID ?? ''
  document.body.appendChild(script)
}
